// PatientFollowUps.jsx
import React, { useState } from "react";
import { FiSearch, FiFilter, FiChevronDown } from "react-icons/fi";
import { FaWhatsapp, FaRegCalendarCheck, FaRegEdit } from "react-icons/fa";
import { Offcanvas } from "react-bootstrap";
import SaleHistory from "./SaleHistory";

const PatientFollowUp = () => {
  const [activeTab, setActiveTab] = useState("Expired");
  const [filterValue, setFilterValue] = useState("FILTER BY");
  const [sortValue, setSortValue] = useState("SORT BY");
  const [show, setShow] = useState(false);

  const patientsData = [
    {
      id: 1,
      initials: "JH",
      name: "Jane",
      phone: "645357589",
      gender: "Female",
      lastSale: "15-Aug-25",
      firstSale: "15-Aug-25",
      followup: "Aug 15, 2025",
      pendingCount: 1,
      bgColor: "#cfd8ff",
      address: "Vizag"
    },
    {
      id: 2,
      initials: "MS",
      name: "Michael Smith",
      phone: "987654321",
      gender: "Male",
      lastSale: "20-Sep-25",
      firstSale: "10-Jul-25",
      followup: "Sep 25, 2025",
      pendingCount: 2,
      bgColor: "#ffd4e5",
      address: "Mumbai"
    },
    {
      id: 3,
      initials: "AL",
      name: "Anna Lopez",
      phone: "456789123",
      gender: "Female",
      lastSale: "05-Oct-25",
      firstSale: "15-Jun-25",
      followup: "Oct 10, 2025",
      pendingCount: 3,
      bgColor: "#e5f3ff",
      address: "Delhi"
    },
    {
      id: 4,
      initials: "RJ",
      name: "Robert Johnson",
      phone: "321654987",
      gender: "Male",
      lastSale: "12-Oct-25",
      firstSale: "25-May-25",
      followup: "Oct 18, 2025",
      pendingCount: 1,
      bgColor: "#fff2cc",
      address: "Bangalore"
    },
    {
      id: 5,
      initials: "EM",
      name: "Emily Martinez",
      phone: "789123456",
      gender: "Female",
      lastSale: "18-Oct-25",
      firstSale: "30-Apr-25",
      followup: "Oct 22, 2025",
      pendingCount: 4,
      bgColor: "#e8f5e8",
      address: "Chennai"
    }
  ];

  const [selectedPatient, setSelectedPatient] = useState(patientsData[0]);

  const handlePatientClick = (patient) => {
    setSelectedPatient(patient);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        gap: "20px",
        padding: "16px",
        backgroundColor: "#f8f9fa",
        overflow: "hidden",
      }}
    >
      {/* Left Panel */}
      <div
        style={{
          width: "330px",
          border: "1px solid #eee",
          borderRadius: "10px",
          padding: "16px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          height: "calc(100vh - 32px)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div style={{ flexShrink: 0 }}>
          <h4 style={{ marginBottom: "4px", fontWeight: 600, fontSize: "18px" }}>
            PATIENT FOLLOW-UPS
          </h4>
          <p style={{ fontSize: "13px", color: "#777", marginBottom: "12px" }}>
            Start building relationship with your customers
          </p>
        </div>

        {/* Tabs */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginBottom: "10px",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              background: "#f6f6f6",
              borderRadius: "6px",
              overflow: "hidden",
              width: "fit-content",
            }}
          >
            {["Arriving", "Expired"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: "8px 16px",
                  border: "none",
                  fontWeight: 500,
                  fontSize: "14px",
                  cursor: "pointer",
                  color: activeTab === tab ? "#fff" : "#333",
                  background: activeTab === tab ? "#297750ff" : "#ecebebff",
                  transition: "0.2s",
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Search Filter Sort Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "13px",
            fontWeight: 500,
            color: "#7eb592",
            marginBottom: "6px",
            gap: "4px",
            flexShrink: 0,
          }}
        >
          <span>Search | Filter | Sort</span>
          <FiChevronDown style={{ transform: "rotate(180deg)" }} />
        </div>

        {/* Filter and Sort Dropdowns */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexShrink: 0 }}>
          {/* Filter Dropdown */}
          <div
            style={{
              flex: 1,
              position: "relative",
            }}
          >
            <FiFilter
              style={{
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
                color: "#666",
                fontSize: "14px",
                marginRight: "10px",
              }}
            />
            <select
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              style={{
                width: "100%",
                padding: "4px 4px 4px 24px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "12px",
                color: "#444",
                appearance: "none",
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
            >
              <option value="FILTER BY">FILTER BY</option>
              <option value="All Patients">All Patients</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Pending">Pending</option>
            </select>
          </div>

          {/* Sort Dropdown */}
          <div
            style={{
              flex: 1,
              position: "relative",
            }}
          >
            <select
              value={sortValue}
              onChange={(e) => setSortValue(e.target.value)}
              style={{
                width: "100%",
                padding: "4px 4px 4px 8px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "12px",
                color: "#444",
                appearance: "none",
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
            >
              <option value="SORT BY">SORT BY</option>
              <option value="Latest Follow-up">Latest Follow-up</option>
              <option value="Oldest Follow-up">Oldest Follow-up</option>
              <option value="Name A–Z">Name A–Z</option>
              <option value="Name Z–A">Name Z–A</option>
            </select>
          </div>
        </div>

        {/* Search Input */}
        <div
          style={{
            position: "relative",
            marginBottom: "14px",
            flexShrink: 0,
          }}
        >
          <FiSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              color: "#aaa",
            }}
          />
          <input
            type="text"
            placeholder="Customer using Name or Contacts"
            style={{
              width: "100%",
              padding: "8px 8px 8px 32px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "13px",
            }}
          />
        </div>

        {/* Patient Cards - Scrollable */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            paddingRight: "4px",
          }}
        >
          {patientsData.map((patient) => (
            <div
              key={patient.id}
              onClick={() => handlePatientClick(patient)}
              style={{
                display: "flex",
                padding: "10px",
                borderTop: "1px solid #f0f0f0",
                cursor: "pointer",
                borderLeft: selectedPatient?.id === patient.id ? "3px solid #7eb592" : "3px solid transparent",
                borderRadius: "6px",
                marginBottom: "8px",
                backgroundColor: selectedPatient?.id === patient.id ? "#f8fffe" : "#fff",
                transition: "all 0.2s ease",
              }}
            >
              <div
                style={{
                  width: "38px",
                  height: "38px",
                  backgroundColor: patient.bgColor,
                  borderRadius: "12px",
                  textAlign: "center",
                  lineHeight: "38px",
                  fontWeight: 600,
                  color: "#333",
                  marginRight: "12px",
                }}
              >
                {patient.initials}
              </div>

              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: "14px" }}>
                  {patient.name}
                </div>
                <div style={{ fontSize: "13px", color: "#777" }}>
                  {patient.phone} - {patient.gender}
                </div>
                <div style={{ fontSize: "12px", color: "#aaa" }}>
                  Last Sale: {patient.lastSale} <br />
                  First Sale: {patient.firstSale}
                </div>
                <div style={{ fontSize: "12px", color: "#888", marginTop: "2px" }}>
                  Followup: {patient.followup}
                </div>
              </div>

              <div>
                <p
                  style={{
                    backgroundColor: "#ebfaf4ff",
                    color: "#7eb592",
                    fontSize: "12px",
                    padding: "3px 8px",
                    borderRadius: "12px",
                    fontWeight: 600,
                  }}
                >
                  {patient.pendingCount} Pending
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel */}
      <div
        style={{
          flex: 1,
          border: "1px solid #eee",
          borderRadius: "10px",
          padding: "16px",
          backgroundColor: "#fff",
          boxShadow: "0 0 10px rgba(0,0,0,0.05)",
          fontSize: "14px",
          color: "#333",
          height: "calc(100vh - 32px)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {selectedPatient ? (
          <>
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", flexShrink: 0 }}>
              {/* Left: Profile Info */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: selectedPatient.bgColor,
                    borderRadius: "12px",
                    textAlign: "center",
                    lineHeight: "50px",
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginRight: "10px",
                    color: "#333",
                  }}
                >
                  {selectedPatient.initials}
                </div>
                <div>
                  <h4 style={{ margin: 0, fontSize: "16px",fontWeight:600 }}>
                    {selectedPatient.name.toUpperCase()}
                  </h4>
                  <div style={{ display:'flex',fontSize: "13px", color: "#555",gap:5 }}>
                    First Sale: <p style={{fontWeight:600,color:'#000'}}>{selectedPatient.firstSale.replace('-', '–')}</p>
                  </div>
                  <div style={{ display:'flex',fontSize: "13px", color: "#555",gap:5 }}>
                    Contact: <p style={{fontWeight:600,color:'#000'}}>{selectedPatient.phone} - {selectedPatient.gender}</p>
                  </div>
                  <div style={{ display:'flex',fontSize: "13px", color: "#555",gap:5 }}>
                    Address: <p style={{fontWeight:600,color:'#000'}}>{selectedPatient.address}</p>
                  </div>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setShow(true);
                    }}
                    style={{
                      color: "#7eb592",
                      fontSize: "13px",
                      fontWeight: "700",
                      display: "inline-block",
                      marginTop: "4px",
                      textDecoration: "none",
                    }}
                  >
                    View Sales History →
                  </a>
                </div>
              </div>

              {/* Right: Edit Button */}
              {/* <button
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems:'center',
                  alignSelf: "flex-end",
                  gap: "6px",
                  cursor: "pointer",
                }}
                className="gradient-dark-button"
              >
                <FaRegEdit />
                Edit Customer
              </button> */}
            </div>

            {/* Follow-up Header Row */}
            <div
              style={{
                backgroundColor: "#ebfaf4ff",
                padding: "10px 16px",
                borderRadius: "8px",
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              {/* Left: Checkbox and Label */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  style={{
                    marginRight: "8px",
                    width: "16px",
                    height: "16px",
                  }}
                />
                <span style={{ fontSize: "14px", color: "#333" }}>
                  Select All ({selectedPatient.pendingCount} follow ups)
                </span>
              </div>

              {/* Right: Action Buttons */}
              <div style={{ display: "flex", gap: "10px" }}>

                {/* Followed Up Button */}
                <button
                  style={{
                    backgroundColor: "#fff",
                    color: "#7eb592",
                    border: "1px solid #54c190ff",
                    borderRadius: "8px",
                    padding: "6px 12px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 500,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  <FaRegCalendarCheck style={{ marginRight: "6px" }} />
                  Followed up
                </button>
              </div>
            </div>

            {/* Scrollable Content Area */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                marginTop: "16px",
              }}
            >
              {/* Prescription Card */}
              <div
                style={{
                  padding: "12px",
                  backgroundColor: "#f8f9fc",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  marginBottom: "16px",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                      <a
                        href="#"
                        style={{ color: "#0e0e0eff", textDecoration: "underline" }}
                      >
                        Medplus, Gajuwaka, Visakhapatnam
                      </a>
                    </p>

                    <span
                      style={{
                        display: "inline-block",
                        backgroundColor: "#7eb592",
                        color: "#fff",
                        fontSize: "12px",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        marginBottom: "10px",
                      }}
                    >
                      Rx - OTC
                    </span>

                    <span
                      style={{
                        marginLeft: "10px",
                        fontSize: "12px",
                        color: "#666",
                      }}
                    >
                      1.00 unit(s) consumed daily*
                    </span>
                  </div>

                  {/* Feedback */}
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      gap: "10px",
                      fontSize: "10px",
                    }}
                  >
                    <span>Mark as</span>
                    <span style={{ color: "#7eb592", cursor: "pointer" }}>
                      Helpful
                    </span>
                    <span style={{ color: "red", cursor: "pointer" }}>
                      | Not Helpful
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "16px",
                    gap: "10px",
                  }}
                >
                  <div>
                    <div style={{ fontWeight: "semibold",fontSize:12 }}>LAST BOUGHT</div>
                    <div style={{ fontWeight: "bold",fontSize:18  }}>2 units</div>
                    <div style={{ fontSize: "12px", color: "#777" }}>
                      on Oct 15, 2025
                    </div>
                  </div>
                  <div>
                    <div style={{ fontWeight: "semibold",fontSize:12 }}>NEXT REFILL*</div>
                    <div style={{ fontWeight: "bold",fontSize:18  }}>2 units</div>
                    <div style={{ fontSize: "12px", color: "#777" }}>
                      on Oct 14, 2025
                    </div>
                  </div>
                  <div>
                    <div style={{ fontWeight: "bold" }}>BRAND(S)</div>
                    <div>Ibuprufen 500 mg</div>
                    <a
                      href="#"
                      style={{
                        color: "#7eb592",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      Check Current Stock
                    </a>
                  </div>
                  <div>
                    <div style={{ fontWeight: "bold" }}>UNITS LEFT*</div>
                    <div style={{ color: "red", fontWeight: 600 }}>0 units</div>
                    <div style={{ fontSize: "12px", color: "#777" }}>
                      over by Aug 14, 2025
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional prescription cards can be added here */}
            </div>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "#999",
              fontSize: "16px",
            }}
          >
            Select a patient to view details
          </div>
        )}
      </div>

      {/* Offcanvas for Sales History */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="end"
        style={{ width: "600px", maxWidth: "100%" }}
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <SaleHistory />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default PatientFollowUp;
